export const maxWidth = 1220;

export const breakpoints = {
  base: 0,
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1280,
  "2xl": 1536,
};

export const breakpointOrder = Object.keys(breakpoints);
